export default function detectBrowserLanguage() {
  const { navigator } = window;

  if (navigator) {
    let languageList = [];

    if (navigator.languages) {
      languageList = languageList.concat(navigator.languages);
    }
    if (navigator.language) {
      languageList.push(navigator.language);
    }
    if (navigator.userLanguage) {
      languageList.push(navigator.userLanguage);
    }
    if (navigator.browserLanguage) {
      languageList.push(navigator.browserLanguage);
    }
    if (navigator.systemLanguage) {
      languageList.push(navigator.systemLanguage);
    }

    if (languageList.length > 0) {
      return languageList[0];
    }
  }

  return undefined;
}
